import React, { useEffect, useState } from 'react';
import chroBg from '../../assets/chro-bg.png';
import { Button } from 'antd';

import { connect } from 'react-redux';
import { setIntroSteps, setStep } from '../../reduxStore/actions/action';

function ChroPage({ setStep, chroAssets, isGamePaused, setIntroSteps }) {
    const [iframeSrc, setIframeSrc] = useState('');
    const [iframeTitle, setIframeTitle] = useState('Content');
    const [iframeAllow, setIframeAllow] = useState('');
    let url = chroAssets?.chro;
    useEffect(() => {
        setIntroSteps(0)
    }, [])
    useEffect(() => {
        if (!url) return;

        if (url.endsWith('.pdf')) {
            // PDF content
            setIframeSrc(`https://docs.google.com/viewer?url=${url}&embedded=true`);
            setIframeTitle('PDF Document');
            setIframeAllow('');
        } else if (url.includes('youtube.com') || url.includes('youtu.be')) {
            // YouTube video
            const videoId = url.includes('youtube.com')
                ? new URL(url).searchParams.get('v')
                : url.split('/').pop();
            setIframeSrc(`https://www.youtube.com/embed/${videoId}`);
            setIframeTitle('YouTube Video');
            setIframeAllow('accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        } else if (url.match(/\.(jpeg|jpg|gif|png)$/) != null) {
            // Image content
            setIframeSrc(url);
            setIframeTitle('Image');
            setIframeAllow('');
        } else {
            // Other content
            setIframeSrc(url);
            setIframeTitle('Content');
            setIframeAllow('');
        }
    }, [url]);

    const audio = document.getElementById("audio-tag");
    if (audio) {
        audio?.pause()?.catch(error => {
            console.error("Error pausing audio:", error);
        });
    }
    return (
        <div className='r-c-c-c m-t-10' style={{ width: '100%', height: '100%', position: 'relative' }}>
            <div className='' style={{ maxWidth: '55%', position: 'relative' }}>
                <img className='full-img' src={chroBg} alt="Background" />

                <iframe
                    className='r-c-c'
                    title={iframeTitle}
                    src={iframeSrc}
                    style={{
                        position: 'absolute',
                        top: iframeTitle == "Image" ? "12%" : '7%',
                        left: iframeTitle == "Image" ? "11%" : '7%',
                        width: iframeTitle == "Image" ? "100%" : '85%',
                        height: iframeTitle == "Image" ? "80%" : '85%',
                        border: 'none',
                        padding: "10px",
                        overflow: "auto"

                    }}
                    allow={iframeAllow}
                    allowFullScreen
                    pause={isGamePaused}
                ></iframe>
            </div>
            <div className='r-c-c done-btn-learning'>
                <Button onClick={() => {
                    setStep(-2);

                    const audio = document.getElementById("audio-tag");
                    if (audio) {

                        audio?.play()?.catch(error => {
                            console.error("Error playing audio:", error);
                        });


                    }
                }} >Next</Button>
            </div>
            {/* <div className='r-c-c p-10' style={{ fontSize: 14, color: "#44301E", position: "absolute", bottom: 5, fontWeight: 600 }} >Powered by The Gamification Company</div> */}
        </div >
    );
}

const mapStateToProps = state => {
    const { step, chroAssets, isGamePaused } = state?.SeTu;
    return { step, chroAssets, isGamePaused }
}


const mapDispatchToProps = dispatch => ({
    setStep: (val) => dispatch(setStep(val)),
    setIntroSteps: (val) => dispatch(setIntroSteps(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChroPage);
